import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=0554aca8&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=ts"
export * from "./Delete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554aca8",
  null
  
)

export default component.exports